<section class="login-section">
    <div class="logo-section">
        <img class="logo" src="assets/images/kangologo.png">
    </div>
    <div class="email-section forgot-psw">
        <h3>Forgot Password</h3>
        <p>Welcome to Kango Express! Please enter your username/email to reset password.</p>
        <form [formGroup]="forgorPasswordForm" (ngSubmit)="onFormSubmit()">
            <div class="kg-form-data login-data mt-5">
                <div class="form-row">
                    <div class="form-group col-md-12 mb-0 text-left mt-0">
                        <label class="label-txt" for="tnumber">Email Address <span class="error">*</span></label>
                        <input floatinput type="email" formControlName="email" class="form-control">
                        <span class="error"
                            *ngIf="forgorPasswordForm.get('email').touched && forgorPasswordForm.get('email').errors?.required">
                            Please enter email
                        </span>
                        <span class="error"
                            *ngIf="forgorPasswordForm.get('email').touched && forgorPasswordForm.get('email').errors?.email">
                            Please enter valid email
                        </span>
                    </div>
                </div>

                <!-- Invisible reCAPTCHA -->
                <div>
                    <re-captcha
                        size="invisible"
                        #invisible
                        [siteKey]="CaptchSiteKey"
                        (errored)="onErrorCaptcha()"
                        errorMode="handled"
                        (resolved)="reCaptchResolve($event)">
                    </re-captcha>
                </div>

                <div class="row">
                    <div class="form-group col-md-12 mt-3">
                        <button type="submit" [disabled]="!forgorPasswordForm.valid || isLoadingResults || isCaptchaExecuting || !buttonEnabled"
                            class="btn btn-info btn-block btn-reset">
                            <span class="fa fa-spinner fa-spin" *ngIf="isLoadingResults || isCaptchaExecuting"></span>
                            Reset <span *ngIf="timerText">({{timerText}})</span></button>
                    </div>
                </div>
                <div class="mt-4 mb-4">
                    <div class="or-line">
                        <h3>or</h3>
                    </div>
                </div>
                <div class="form-group">
                    <p class="text-center">Already signed up? <a class="orange" [routerLink]="['/login']">Log In</a></p>
                </div>
            </div>
        </form>
    </div>
</section>